<template>
  <div class="p-grid">
    <div class="p-col-12">
      <div class="card" id="followupApprovalPage">
        <h4>Approve Follow-up Email<span v-if="data"> for Quote: {{ data.quoteRef }}<span v-if="data.project"> - {{ data.project }}</span></span></h4>
        <p v-if="loadError" class="p-invalid">{{ loadError }}</p>
        <template v-if="data">
          <p>
            Please read the text below and approve for this email to be sent out to:
            <b>{{ data.contactName }}</b><span v-if="data.contactEmail"> / {{ data.contactEmail }}</span>.
            <span v-if="data.dueAt"> It is due to go on {{ data.dueAt }}.</span>
            <router-link v-if="data.oppId" :to="'/enquiries/' + data.oppId + '/followup'">Open the quote's Follow-up tab</router-link>
          </p>
          <div v-if="!data.waitingForApproval" id="notWaiting" class="p-message-text p-mb-3">
            This follow-up is not waiting for approval any more (it is {{ (data.state || '').toLowerCase() }}).
          </div>

          <div class="email-box p-mb-3">
            <div><b>Subject:</b> {{ data.subject }}</div>
            <pre class="email-body">{{ data.body }}</pre>
            <small v-if="data.edited" class="hint">This is the text as edited for this quote.</small>
          </div>

          <div v-if="done" id="approvalDone" class="p-mb-3"><b>{{ done }}</b></div>

          <div v-if="data.waitingForApproval && !done">
            <div class="p-d-flex p-mb-3">
              <Button v-for="a in actions" :key="a" :id="'choose-' + a" :label="labels[a]" style="width: auto" class="p-mr-2"
                :class="action === a ? '' : 'p-button-outlined'" @click="action = a" />
            </div>

            <div v-if="action === 'approve'" id="approvePanel">
              <div class="p-field-checkbox">
                <Checkbox id="approveHappy" v-model="form.happy" :binary="true" />
                <label for="approveHappy">I am happy with this email text</label>
              </div>
            </div>

            <div v-if="action === 'edit'" id="editPanel" class="p-fluid">
              <div class="p-field">
                <label for="editSubject">Subject</label>
                <InputText id="editSubject" v-model="form.subject" />
              </div>
              <div class="p-field">
                <label for="editBody">Message</label>
                <Textarea id="editBody" v-model="form.body" :autoResize="true" rows="10" />
                <small class="hint">Your text goes for this quote only. The CRM keeps both versions so Admin can improve the standard wording.</small>
              </div>
            </div>

            <div v-if="action === 'suspend'" id="suspendPanel" class="p-fluid">
              <div v-for="o in suspendOptions" :key="o.value" class="p-field-radiobutton">
                <RadioButton :id="'suspend-' + o.value" name="suspendOption" :value="o.value" v-model="form.suspendOption" />
                <label :for="'suspend-' + o.value">{{ o.label }}</label>
              </div>
              <div v-if="form.suspendOption === 'PAUSE'" class="p-field" style="max-width: 200px">
                <label for="pauseDays">Days</label>
                <InputNumber id="pauseDays" v-model="form.pauseDays" :min="1" :max="365" :useGrouping="false" />
              </div>
              <div class="p-field">
                <label for="suspendReason">Reason</label>
                <Dropdown id="suspendReason" v-model="form.reason" :options="reasonOptions" placeholder="Choose a reason" />
              </div>
              <div v-if="form.reason === other" class="p-field">
                <label for="otherReason">Your reason</label>
                <InputText id="otherReason" v-model="form.otherReason" />
              </div>
            </div>

            <small v-if="problem" class="p-invalid p-d-block p-mb-2">{{ problem }}</small>
            <Button id="sendAnswer" :label="sendLabel" icon="pi pi-check" style="width: auto" :disabled="saving" @click="send" />
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import FollowupService, { errorMessage } from '@/service/FollowupService'
import { ACTIONS, SUSPEND_OPTIONS, OTHER, startAction, answerBody, doneMessage } from './followupApproval'

export default {
  // B3-8 (Mohammed 04/10): opened from the approval email (?action=approve|edit|suspend), after sign-in
  name: 'FollowupApproval',
  data() {
    return {
      followupService: new FollowupService(),
      data: null,
      loadError: '',
      action: startAction(this.$route && this.$route.query),
      actions: ACTIONS,
      labels: { approve: 'Approve', edit: 'Edit', suspend: 'Suspend' },
      suspendOptions: SUSPEND_OPTIONS,
      other: OTHER,
      form: { happy: false, subject: '', body: '', suspendOption: null, pauseDays: 14, reason: null, otherReason: '' },
      problem: '',
      saving: false,
      done: ''
    }
  },
  computed: {
    reasonOptions() { return ((this.data && this.data.reasons) || []).concat([OTHER]) },
    sendLabel() { return this.action === 'edit' ? 'Save and approve' : this.action === 'suspend' ? 'Suspend' : 'Approve' }
  },
  created() {
    this.load()
  },
  methods: {
    load() {
      return this.followupService.approval(this.$route.params.followupId)
        .then(d => {
          this.data = d
          this.form.subject = d.subject || ''
          this.form.body = d.body || ''
        })
        .catch(err => { this.loadError = errorMessage(err, 'This follow-up could not be loaded.') })
    },
    send() {
      var a = answerBody(this.action, this.form)
      if (a.problem) { this.problem = a.problem; return Promise.resolve() }
      this.problem = ''
      this.saving = true
      return this.followupService.answerApproval(this.$route.params.followupId, a.body)
        .then(() => { this.done = doneMessage(this.action, a.body) })
        .catch(err => { this.problem = errorMessage(err, 'Your answer could not be saved.') })
        .finally(() => { this.saving = false })
    }
  }
}
</script>

<style scoped>
.email-box { border: 1px solid #dee2e6; border-radius: 4px; padding: 0.75rem; background: #f8f9fa; }
.email-body { white-space: pre-wrap; font-family: inherit; margin: 0.5rem 0 0; }
.hint { color: #6c757d; }
</style>
